import React from 'react';
import { Col, Empty, Pagination, Row, Spin, Typography } from 'antd';
import { PublicSurveyPageData, PublicSurveyStatus } from '../../types/publicSurvey.types';
import { PublicSurveyCard } from './PublicSurveyCard';

const { Title } = Typography;

const BRAND_INDIGO = '#2E2B81';
const BRAND_GREEN = '#00984A';

interface PublicSurveyListProps {
  title: string;
  showTitle?: boolean;
  data?: PublicSurveyPageData;
  loading: boolean;
  fetching?: boolean;
  page: number;
  onPageChange: (page: number) => void;
  onParticipate?: (surveyId: string) => void;
  getShareUrl?: (surveyId: string, publicAuditHash?: string | null) => string;
}

export const PublicSurveyList: React.FC<PublicSurveyListProps> = ({
  title,
  showTitle = true,
  data,
  loading,
  fetching = false,
  page,
  onPageChange,
  onParticipate,
  getShareUrl,
}) => {
  const status: PublicSurveyStatus = data?.status ?? (onParticipate ? 'ACTIVE' : 'COMPLETED');
  const accentColor = status === 'ACTIVE' ? BRAND_GREEN : '#8c8c8c';
  const items = data?.items ?? [];
  const isSingleItem = items.length === 1;

  return (
    <div style={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 20 }}>
      {showTitle && (
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <div
            style={{
              width: 4,
              height: 22,
              background: accentColor,
              borderRadius: 2,
              flexShrink: 0,
            }}
          />
          <Title level={4} style={{ marginBottom: 0, color: BRAND_INDIGO }}>
            {title}
          </Title>
        </div>
      )}

      {loading ? (
        <div style={{ textAlign: 'center', padding: '48px 0' }}>
          <Spin size="large" />
        </div>
      ) : items.length === 0 ? (
        <Empty
          description="Nenhuma pesquisa encontrada nesta seção"
          style={{ padding: '32px 0' }}
        />
      ) : (
        <div style={{ opacity: fetching ? 0.5 : 1, transition: 'opacity 0.15s ease' }}>
          <Row gutter={[16, 16]}>
            {items.map((item) => (
              <Col xs={24} md={isSingleItem ? 24 : 12} key={item.surveyId}>
                <PublicSurveyCard
                  item={item}
                  status={status}
                  onParticipate={onParticipate}
                  shareUrl={getShareUrl?.(item.surveyId, item.publicAuditHash)}
                />
              </Col>
            ))}
          </Row>
        </div>
      )}

      {(data?.totalItems ?? 0) > 0 && (
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <Pagination
            current={page}
            pageSize={data?.pageSize ?? 10}
            total={data?.totalItems ?? 0}
            onChange={onPageChange}
            showSizeChanger={false}
          />
        </div>
      )}
    </div>
  );
};
